import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "dweb-dealsplatform-page" */ './Desktop')
);
